/**
 * Created by karthikeyan.k on 04-12-2018.
 */
export class Menu {
  menuName: string;
  menuLangCode: string;
  isAvailable: boolean;
  isFullColor: boolean;
  isTradeMarkAtEnd: boolean;
}
